import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal lg-size" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "signatureUploadModal",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Upload Signature "),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, " Upload Signature ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "signature-wrap border p-2 rounded mb-3"
}
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VuePictureCropper = _resolveComponent("VuePictureCropper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSignaturePadModal && _ctx.closeSignaturePadModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            (_ctx.state.data.uploadSignature)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("img", {
                    src: _ctx.state.data.uploadSignature,
                    alt: ""
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.newUploadImge)
              ? (_openBlock(), _createBlock(_component_VuePictureCropper, {
                  key: 1,
                  class: "border p-1 rounded mb-3",
                  boxStyle: {
                      width: '98%',
                      height: '98%',
                      backgroundColor: '#f8f8f8',
                      margin: '0',
                    },
                  img: _ctx.state.data.newUploadImge,
                  options: {
                      viewMode: 1,
                      dragMode: 'crop',
                      aspectRatio: 30 / 20,
                    }
                }, null, 8, ["img"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("button", {
              type: "button",
              class: "btn default-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadUSerSignature && _ctx.uploadUSerSignature(...args)))
            }, "Save"),
            (_ctx.state.data.isuplode)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveSignature && _ctx.saveSignature(...args)))
                }, "Crop"))
              : _createCommentVNode("", true),
            (_ctx.state.data.isuplode)
              ? (_openBlock(), _createBlock("button", {
                  key: 1,
                  class: "btn default-btn",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearCrop && _ctx.clearCrop(...args)))
                }, "Clear Crop"))
              : _createCommentVNode("", true),
            _createVNode("button", {
              class: "btn red-btn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeSignaturePadModal && _ctx.closeSignaturePadModal(...args)))
            }, " Cancel ")
          ])
        ])
      ])
    ])
  ]))
}